import React from 'react';
import { useFormDepartureContext } from '../../../components/FormDepartureContext';
import CustomSelect from '../../../components/shared/CustomSelect';

const TIME_OPTIONS = ['7am', '8am', '9am', '10am', '11am', '12pm', '1pm', '2pm', '3pm', '4pm', '5pm', '6pm', '7pm', '8pm', '9pm'];

const ErrorIcon = () => (
  <svg fill="currentColor" viewBox="0 0 20 20">
    <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
  </svg>
);

const todayStr = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
};

const DatesSection = () => {
  const { formData, formErrors, modifiedFields, setFieldValue, setFormErrors, setModifiedFields } = useFormDepartureContext();

  const applyError = (field, error) => {
    if (error) setFormErrors((prev) => ({ ...prev, [field]: error }));
    else setFormErrors((prev) => { const n = { ...prev }; delete n[field]; return n; });
  };

  const handleDate = (value) => {
    setFieldValue('completedDate', value);
    setModifiedFields((prev) => new Set([...prev, 'completedDate']));
    let error = null;
    if (!value) error = 'Completed Date is required';
    else if (value < todayStr()) error = 'Completed Date cannot be in the past';   // string compare on YYYY-MM-DD
    applyError('completedDate', error);
  };

  const handleTime = (value) => {
    setFieldValue('completedTime', value);
    setModifiedFields((prev) => new Set([...prev, 'completedTime']));
    applyError('completedTime', value ? null : 'Completed Time is required');
  };

  const showErr = (field) => formErrors[field] && modifiedFields?.has?.(field);

  return (
    <div className="form-section">
      <h4 className="ob-record-title" style={{ marginBottom: 12 }}>Dates Information</h4>

      <div style={{ display: 'grid', gap: 20 }}>
      <div className="ob-field">
        <label htmlFor="completed-Date" className="ob-label">Complete Work Date <span className="ob-label-required">*</span></label>
        <input id="completed-Date" type="date" value={formData.completedDate} min={todayStr()}
          onChange={(e) => handleDate(e.target.value)}
          className={`ob-input ${showErr('completedDate') ? 'ob-input-error' : ''}`} />
        {showErr('completedDate') && <div className="ob-error"><ErrorIcon />{formErrors.completedDate}</div>}
      </div>

      <div className="ob-field">
        <CustomSelect label="Completed Time" value={formData.completedTime} onChange={handleTime} options={TIME_OPTIONS} />
        {showErr('completedTime') && <div className="ob-error"><ErrorIcon />{formErrors.completedTime}</div>}
      </div>
      </div>
    </div>
  );
};

export default DatesSection;